import { Component, Input, ViewEncapsulation } from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
@Component({
  selector: 'ui-page-layout',
  templateUrl: './page-layout.component.html',
  styleUrl: './page-layout.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [NzLayoutModule, NzIconModule],
})
export class UIPageLayout {
  @Input() isCollapsed?: boolean = false;
  @Input() logoPath = 'assets/logos/logo-blue.svg';
}
